<template>
  <div id="app">
    <div class="header">
      <modal :show="showModal" @close="showModal = false"></modal>
      <div class="headerContentWrapper">
        <div class="headerContent">
          <div class="logoContainerMain">
            <img class="logo" alt="Orium logo" src="./assets/header_logo-o.svg" />
          </div>
          <div class="ctaContainer">
            <button class="buttonRounded" v-on:click="openGitHub()"><span class="buttonTextOrange">Get Askaway</span></button>
            <div class="logoContainer">
              <button id="show-modal" class="imageButton" @click="showModal = true">
                <span class="buttonTextGrey">Share</span>
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
    <Main />
    <div class="footer">
      <Footer />
    </div>
  </div>
</template>

<script>
import Main from "./components/Main.vue";
import Footer from "./components/Footer.vue";
import modal from "./components/modal.vue";

export default {
  name: "App",
  components: {
    Main,
    Footer,
    modal
  },
  data: function() {
    return {
      showModal: false
    };
  },
  methods: {
    openGitHub() {
      window.open('https://github.com/myplanet/askaway', '_blank')
    },
  },
};
</script>

<style>
body,
html {
  margin: 0;
  padding: 0;
  position: absolute;
  width: 100%;
}
* {
  box-sizing: border-box;
}
#app {
  font-family: "SofiaProRegular";
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
  margin-top: 60px;
  /* margin: 60px 100px 0; */
}
a {
  text-decoration: none;
}
.header {
  display: flex;
  margin: 0 auto;
  width: 100%;
  padding-left: 20%;
  padding-right: 20%;
  background: #fff;
  height: 85px;
  top: 0;
  left: 0;
  display: flex;
  position: fixed;
}

.header .headerContent {
  display: flex;
  z-index: 7;
  padding: 0px;
  padding-bottom: 25px;
  padding-top: 25px;
  background: #fff;
  justify-content: space-between;
  width: 100%;
  border-bottom: 2px solid black;
  height: 85px;
}

.header .headerContentWrapper {
  display: flex;
  z-index: 7;
  padding: 0px;
  padding-bottom: 25px;
  background: #fff;
  width: 100%;
  height: 85px;
}

.header .caps {
  text-transform: uppercase;
  font-size: 12px;
  height: 20px;
  color: #f25930;
  font-size: 12px;
  font-weight: bold;
  letter-spacing: 1.2px;
  line-height: 23px;
}

.header .ctaContainer {
  display: flex;
  align-items: center;
}

.logoContainer {
  display: flex;
  align-items: center;
}

.logoContainer .logo {
  height: 25px;
  display: none;
}

.logoContainerMain {
  display: flex;
  align-items: center;
}

.logoContainerMain .logo {
  height: 36px;
}

.appname {
  height: 22px;
  width: 100px;
  color: #2a2a49;
  font-size: 24px;
  letter-spacing: 0;
  line-height: 23px;
  font-family: "SofiaProBold";
  margin-left: -70px;
}

.text {
  font-weight: bold;
}

.header .caps.modalstyle {
  z-index: 13;
  height: 20px;
  color: #66646b;
  font-size: 12px;
  font-weight: bold;
  letter-spacing: 1.2px;
  line-height: 20px;
  padding: 0;
}

.buttonRounded {
  cursor: pointer;
  height: 40px;
  width: 142px;
  border-radius: 50px;
  border: 0px;
  background-color: #ffffff;
  border: 2px solid #f25930;
}

.buttonRounded:hover,
.buttonRounded:hover .buttonTextOrange {
  background-color: #f25930;
  color: #ffffff;
}

.buttonTextOrange {
  color: #f25930;
  text-transform: uppercase;
  letter-spacing: 0.00938em;
  line-height: 20px;
  font-size: 12px;
  font-family: "SofiaProBold";
}

.buttonTextGrey {
  text-transform: uppercase;
  font-family: "SofiaProBold";
  font-size: 12px;
  color: #66646B;
  margin: 1em;
  line-height: 25px;
}

.imageButton {
  cursor: pointer;
  background: #fff url('./assets/share_sign_grey.svg') no-repeat top right;
  background-size: 25px 25px;
  background-position-y: 7.5px;
  height: 40px;
  border: none;
  padding-right: 2em;
}

.imageButton:hover {
  background: #fff url('./assets/share_sign_orange.svg') no-repeat top right;
  background-size: 25px 25px;
  background-position-y: 7.5px;
}

.imageButton:hover .buttonTextGrey {
  color:#f25930;
}

@media only screen and (min-width: 1200px) and (max-width: 1448px) {
  #app {
    width: 1200px;
    margin: 0 auto;
  }
}

@media only screen and (min-width: 1029px) and (max-width: 1199px) {
  #app {
    width: 1000px;
    margin: 0 auto;
  }

  .header .headerContent {
    width: 1000px;
    margin: 0 auto;
  }
}

@media only screen and (min-width: 823px) and (max-width: 1028px) {
  #app {
    width: 800px;
    margin: 0 auto;
  }

  .header {
    padding-left: 5%;
    padding-right: 5%;
  }

  .header .headerContent {
    width: 800px;
    margin: 0 auto;
  }
}

@media only screen and (min-width: 515px) and (max-width: 823px) {
  #app {
    width: 600px;
    margin: 0 auto;
  }

  .header {
    padding-left: 5%;
    padding-right: 5%;
  }

  .header .headerContent {
    width: 600px;
    margin: 0 auto;
  }
}
@media only screen and (min-width: 375px) and (max-width: 515px) {
  #app {
    margin: 0 auto;
  }

  .buttonTextGrey {
    display: none;
  }

  .header .headerContentWrapper {
    height: 90px;
    padding-bottom: 25px;
  }

  .header {
    padding-left: 5%;
    padding-right: 5%;
    height: 90px;
  }

  .header .headerContent {
    height: 90px;
  }

  .logoContainerMain .logo {
    height: 40px;
  }

  .buttonRounded {
    height: 40px;
    width: 130px;
  }

  .buttonTextOrange {
    font-size: 13px;
  }

  .imageButton {
    background: #fff url('./assets/share_sign_grey.svg') no-repeat top right;
    background-size: 30px 30px;
    height: 40px;
    width: 40px;
    border: none;
    padding-right: 2em;
    margin-top: 10px;
  }
}

@font-face {
  font-family:"SofiaProBold";
  src:local("SofiaProBold"),
  url(./fonts/SofiaProBold.ttf)
  format("truetype")
}

@font-face {
  font-family:"SofiaProRegular";
  src:local("SofiaProRegular"),
  url(./fonts/SofiaProRegular.ttf)
  format("truetype")
}
</style>
